module.exports = __webpack_public_path__ + "static/jon-micah.e03a35af.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/avatars/jon-micah.jpg
// module id = 279
// module chunks = 168707334958949